import { useState, useEffect } from 'react';
import 'intersection-observer';

export default function useIntersectionObserver(root, thresholds, handler) {
    const [currentObserver, setCurrentObserver] = useState(null);

    useEffect(() => {
        if (currentObserver) {
            currentObserver.disconnect();
            setCurrentObserver(null);
        }

        if (root && handler) {
            setCurrentObserver(new IntersectionObserver(handler, {
                root,
                rootMargin: '0px',
                threshold: thresholds || 0
            }));
        }

        return () => {
            if (currentObserver) {
                currentObserver.disconnect();
            }
        };
    },
    // eslint-disable-next-line
    [root, thresholds, handler]);

    return currentObserver;
}
